import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng9RutModule } from 'ng9-rut';
import { MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { SharedModule } from 'src/app/shared/shared.module';
import { SharedViewsModule } from '../shared/shared-views.module';

import { CartolaClienteComponent } from './cartola-cliente/cartola-cliente.component';
import { PagosClienteComponent } from './pagos-cliente/pagos-cliente.component';
import { CabeceraComponent as CabeceraComponentPagosClientes } from './pagos-cliente/cabecera/cabecera.component';
import { DocsCtasComponent } from './pagos-cliente/docs-ctas/docs-ctas.component';
import { FormasPagoComponent } from './pagos-cliente/formas-pago/formas-pago.component';
import { FormasPagoTabsComponent } from './pagos-cliente/formas-pago-tabs/formas-pago-tabs.component';
import { ModalControlEfectivoComponent } from './pagos-cliente/modal-control-efectivo/modal-control-efectivo.component'
import { ModalFoliosLiquidacionComponent } from './pagos-cliente/modal-folios-liquidacion/modal-folios-liquidacion.component';
import { ReversoPagosComponent } from './reverso-pagos/reverso-pagos.component';
import { ModalAddEditReversoPagoComponent } from './reverso-pagos/modal-add-edit-reverso-pago/modal-add-edit-reverso-pago.component';
import { CabeceraComponent as CabeceraComponentReversoPagos } from './reverso-pagos/cabecera/cabecera.component'
import { DetallesComponent } from './reverso-pagos/detalles/detalles.component';
import { ClientesMorososComponent } from './clientes-morosos/clientes-morosos.component'
import { SaldoClientesComponent } from './saldo-clientes/saldo-clientes.component'
import { ConsultarPagosComponent } from "./consultar-pagos/consultar-pagos.component";
import { ConsultarPagosModalViewDetailsComponent } from "./consultar-pagos/modal-view-details/modal-view-details.component";
import { ModalViewDetailsPagoComponent } from "./cartola-cliente/modal-view-details-pago/modal-view-details-pago.component";
import { DocumentoPorCobrarComponent } from "../documento-por-cobrar/documento-por-cobrar.component";
import { ModalSeleccionDocumentoAjusteComponent } from "../documento-por-cobrar/modal-seleccion-documento-ajuste/modal-seleccion-documento-ajuste.component";
import { ModalAddPagoComponent } from './reverso-pagos/modal-add-pago/modal-add-pago/modal-add-pago.component';

@NgModule({
  declarations: [
    CartolaClienteComponent,
    PagosClienteComponent,
    CabeceraComponentPagosClientes,
    DocsCtasComponent,
    FormasPagoComponent,
    FormasPagoTabsComponent,
    ModalControlEfectivoComponent,
    ModalFoliosLiquidacionComponent,
    ReversoPagosComponent,
    ModalAddEditReversoPagoComponent,
    CabeceraComponentReversoPagos,
    DetallesComponent,
    ClientesMorososComponent,
    DocumentoPorCobrarComponent,
    SaldoClientesComponent,
    ConsultarPagosComponent,
    ConsultarPagosModalViewDetailsComponent,
    ModalViewDetailsPagoComponent,
    ModalAddPagoComponent,
    ModalSeleccionDocumentoAjusteComponent
  ],
  imports: [
    CommonModule,
    ToastModule.forRoot(),
    MDBBootstrapModulesPro.forRoot(),
    Ng9RutModule,
    FormsModule,
    ReactiveFormsModule,
    SharedViewsModule,
    SharedModule
  ],
  exports: [
    CartolaClienteComponent,
    PagosClienteComponent,
    ReversoPagosComponent,
    SaldoClientesComponent
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class CtaCteClienteModule { }
